import { APP_DEFAULT_PATH, APP_DEFAULT_PATH_MY } from 'config';
import useAuthorization from './useAuthorization';

const useDefaultPath = () => {
  const { current } = useAuthorization();

  const isRequester = current?.permission === 'requester';

  return isRequester ? APP_DEFAULT_PATH_MY : APP_DEFAULT_PATH;
};

export default useDefaultPath;
